import React from 'react';
import { observer } from 'mobx-react';

import { useStore } from 'core/store';
import { Loading } from 'core/components/loading';
import { Card } from 'core/components/card';
import { isCondensedLayout } from 'core/components/theme/condensed-layout';
import { Additionals } from 'offer/components/sidebar/components/additionals';
import { DocumentsSharing } from 'offer/components/sidebar/components/documents-sharing';
import QuoteFacts from 'quote-revisit/modify-quote/header/quote-facts';
import { CheckoutPolicyCards } from './policy-cards';
import useStyles from './left-column.styles';

/**
 * Checkout's left column for Staff Quote Revisit (#32313). The policy cards are a mount point for
 * #36363; Additionals and Documents & sharing render today's components unchanged. In the condensed layout the
 * header's pre-bind ID, rep and quote source show here instead.
 */
const CheckoutLeftColumn = observer(() => {
  const classes = useStyles();
  const { offer: store } = useStore();

  if (!store.offer) {
    return <Loading />;
  }

  return (
    <div className={classes.leftColumn}>
      <div className={classes.columnHeader} />
      <CheckoutPolicyCards />
      {isCondensedLayout() && (
        <Card className={classes.factsCard}>
          <QuoteFacts fromCheckout condensed />
        </Card>
      )}
      {store.shouldShowAdditionalPaymentsSection && <Additionals />}
      <DocumentsSharing />
    </div>
  );
});

export default CheckoutLeftColumn;
